
export const UNIFIED_CREDITS_USAGE_PRODUCT_NAME_KEYS = {
  'basic-listing': 'unifiedBadgeNormal',
  'basic-listing-dubizzle': 'unifiedBadgeNormal',
  basic: 'unifiedBadgeNormal',
  'hot-listing': 'unifiedBadgeFeatured',
  hot: 'unifiedBadgeFeatured',
  feature: 'unifiedBadgeFeatured',
  'signature-listing': 'unifiedBadgeElite',
  signature: 'unifiedBadgeElite',
  refresh: 'Boost to Top',
  'boost-to-top': 'Boost to Top',
};

/** Usage Breakdown / donut segment colors for unified Oman credits usage */
export const UNIFIED_CREDITS_USAGE_PRODUCT_COLORS = {
  'basic-listing': '#71A7AC',
  'basic-listing-dubizzle': '#71A7AC',
  basic: '#71A7AC',
  'hot-listing': '#84BEF2',
  hot: '#84BEF2',
  feature: '#84BEF2',
  'signature-listing': '#F2B662',
  signature: '#F2B662',
  refresh: '#69C899',
  'boost-to-top': '#69C899',
};

const normalizeSlug = (slug) => {
  if (!slug || typeof slug !== 'string') return null;
  if (UNIFIED_CREDITS_USAGE_PRODUCT_NAME_KEYS[slug]) return slug;
  const dashed = slug.replace(/_/g, '-');
  return UNIFIED_CREDITS_USAGE_PRODUCT_NAME_KEYS[dashed] ? dashed : slug;
};

export const getUnifiedCreditsUsageProductNameKey = (slug) => {
  const n = normalizeSlug(slug);
  return UNIFIED_CREDITS_USAGE_PRODUCT_NAME_KEYS[n] ?? null;
};

export const getUnifiedCreditsUsageProductColor = (slug) => {
  const n = normalizeSlug(slug);
  return n ? UNIFIED_CREDITS_USAGE_PRODUCT_COLORS[n] ?? null : null;
};

export const mapProductForUnifiedCreditsUsage = (product) => {
  if (!product?.slug) return product;
  const nameKey = getUnifiedCreditsUsageProductNameKey(product.slug);
  if (!nameKey) return product;
  return {
    ...product,
    name: nameKey,
  };
};

export const mapConsumptionSummaryRowForUnifiedCreditsUsage = (row) => {
  const nameKey = getUnifiedCreditsUsageProductNameKey(row.slug);
  if (!nameKey) return row;
  return {
    ...row,
    title: nameKey,
    title_l1: nameKey,
  };
};
